import { render, staticRenderFns } from "./Ads.vue?vue&type=template&id=58a08cf8&"
import script from "./Ads.vue?vue&type=script&lang=ts&"
export * from "./Ads.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports